import { Injector } from '@angular/core';
import { Section } from './Section';
import { PostState } from '../Data/PostData/PostState';
import { ValidationResult } from '../Data/PostData/ValidationResult';

export class PostSection extends Section implements PostState {
  /* PostState model being preserved in memory: */
  selectedFile: File | null = null;
  fileContent: string = '';
  validationResult: ValidationResult = { ok: false, message: '', title: '' };
  objectUrl: string | null = null;

  /* constructor */
  constructor(injector: Injector) {
    super(injector);
  }

  setSelectedFile(file: File | null) {
    this.revokeObjectUrl();
    this.selectedFile = file;
    this.fileContent = '';
    this.validationResult = { ok: false, message: '', title: '' }
  }

  setFileContent(content: string) {
    this.fileContent = content;
  }

  setValidation(validationResult: ValidationResult) {
    this.validationResult = validationResult
  }

  createObjectUrlForSelectedFile() : string | null {
    if (!this.selectedFile) return null;
    this.revokeObjectUrl();
    this.objectUrl = URL.createObjectURL(this.selectedFile);
    return this.objectUrl;
  }

  revokeObjectUrl(): void {
    if (this.objectUrl) {
      try { URL.revokeObjectURL(this.objectUrl); } catch (e) { /* ignore */ }
      this.objectUrl = null;
    }
  }

  override resetSection(): void {
    this.setSelectedFile(null);
    this.revokeObjectUrl();
  }
}